var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import config from 'core/config';
var baseUrl = config.baseurl + '/' + document.querySelector('html').getAttribute('lang').split('-')[0] + '/api/capency';
var headers = {
    'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
};
export var CAPENCY_DEFAULT_COUNTRIES = ['FR', 'UK', 'LU', 'BE', 'CH'];
var cache = {
    mail: {},
    phone: {}
};
var checkMail = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var p;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!cache.mail[value]) return [3 /*break*/, 2];
                return [4 /*yield*/, cache.mail[value]];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                p = (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var request, response, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 3, , 4]);
                                return [4 /*yield*/, fetch("".concat(baseUrl, "?api=email&sMail=").concat(value, "&request=CheckMailSrvWS"), {
                                        method: 'POST',
                                        headers: __assign({}, headers)
                                    })];
                            case 1:
                                request = _a.sent();
                                return [4 /*yield*/, request.json()];
                            case 2:
                                response = _a.sent();
                                if (response.body.error) {
                                    throw new Error(response.error.message);
                                }
                                else {
                                    return [2 /*return*/, {
                                            error: response.body.iRet >= 1,
                                            message: response.body.sMessage
                                        }];
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                e_1 = _a.sent();
                                console.log("[CAPEMAIL] an error occured : ".concat(e_1));
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); })();
                return [4 /*yield*/, (cache.mail[value] = p)];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getPhoneMessage = function (code, country) { return __awaiter(void 0, void 0, void 0, function () {
    var request, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(baseUrl, "?api=phone&country=").concat(country, "&request=GetMessageCP&iReturnValue=").concat(code), {
                    method: 'POST',
                    // charset utf8
                    headers: __assign({}, headers)
                })];
            case 1:
                request = _a.sent();
                return [4 /*yield*/, request.json()];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.body];
        }
    });
}); };
var checkPhone = function (number, country) { return __awaiter(void 0, void 0, void 0, function () {
    var p;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!cache.phone[number]) return [3 /*break*/, 2];
                return [4 /*yield*/, cache.phone[number]];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                if (!number)
                    return [2 /*return*/, { error: true, message: 'Phone number is empty' }];
                p = (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var request, response, messageRequest, e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 6, , 7]);
                                return [4 /*yield*/, fetch("".concat(baseUrl, "?api=phone&sTel=").concat(number, "&country=").concat(country, "&request=ProcessPhoneFlow"), {
                                        method: 'POST',
                                        headers: __assign({}, headers)
                                    })];
                            case 1:
                                request = _a.sent();
                                return [4 /*yield*/, request.json()];
                            case 2:
                                response = _a.sent();
                                if (!(response.body.iReturnValue === 0)) return [3 /*break*/, 3];
                                return [2 /*return*/, {
                                        error: false
                                    }];
                            case 3: return [4 /*yield*/, getPhoneMessage(response.body.iReturnValue, country)];
                            case 4:
                                messageRequest = _a.sent();
                                return [2 /*return*/, {
                                        error: true,
                                        message: messageRequest.sMessage === 'Rejetée' ? config.errors.capencyWrongNumber : messageRequest.message
                                    }];
                            case 5: return [3 /*break*/, 7];
                            case 6:
                                e_2 = _a.sent();
                                console.log('[CAPHONE] an error occured :', e_2);
                                return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); })();
                return [4 /*yield*/, (cache.phone[number] = p)];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var searchAddress = function (query, country) { return __awaiter(void 0, void 0, void 0, function () {
    var encodedQuery;
    return __generator(this, function (_a) {
        encodedQuery = encodeURIComponent(query);
        return [2 /*return*/, fetch("".concat(baseUrl, "?api=address&step=Undefined&country=").concat(country, "&request=SearchLine&inputOutput=").concat(encodedQuery), {
                method: 'POST',
                headers: __assign({}, headers)
            })];
    });
}); };
var verifyAddress = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var encodedQuery, request, response, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // create a string with all parameters chained
                if (params.country === 'MC')
                    params.locality = 'MONACO';
                encodedQuery = Object.keys(params).map(function (key) { return "".concat(key, "=").concat(encodeURIComponent(params[key])); }).join('&');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "?api=address&request=VerifyAddress&").concat(encodedQuery), {
                        method: 'POST',
                        headers: __assign({}, headers)
                    })];
            case 2:
                request = _a.sent();
                return [4 /*yield*/, request.json()];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.body];
            case 4:
                e_3 = _a.sent();
                console.log(e_3);
                return [2 /*return*/, {
                        error: true,
                        message: 'An error occured'
                    }];
            case 5: return [2 /*return*/];
        }
    });
}); };
var getAvailableCountries = function () { return __awaiter(void 0, void 0, void 0, function () {
    var request, response, e_4;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "?api=address&request=GetAvailableCountries"), {
                        method: 'POST',
                        headers: __assign({}, headers)
                    })];
            case 1:
                request = _c.sent();
                return [4 /*yield*/, (request === null || request === void 0 ? void 0 : request.json())];
            case 2:
                response = _c.sent();
                if ((_b = (_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.countries) === null || _b === void 0 ? void 0 : _b.country)
                    return [2 /*return*/, response.body.countries.country.map(function (country) { return country.countryCode.slice(0, 2); })];
                else
                    return [2 /*return*/, CAPENCY_DEFAULT_COUNTRIES];
                return [3 /*break*/, 4];
            case 3:
                e_4 = _c.sent();
                return [2 /*return*/, CAPENCY_DEFAULT_COUNTRIES];
            case 4: return [2 /*return*/];
        }
    });
}); };
export default {
    checkMail: checkMail,
    checkPhone: checkPhone,
    searchAddress: searchAddress,
    verifyAddress: verifyAddress,
    getAvailableCountries: getAvailableCountries
};
